<template>
  <div class="tutorial-page row-block default-shadow" :style="{ minHeight: minHeight }">
    <div class="menu-container" :style="{ width: '250px' }">
      <div class="tutorial-menu-page col-block default-shadow" :style="{ height: minHeight }">
        <div class="title-container center-block">
          <div class="title">介紹與教學</div>
        </div>
        <div class="main-container" :style="{ flex: 1 }">
          <ul class="custom">
            <li>
              <span @click="e => scrollTo('農產業貿易潛力分析平台')">本平台介紹</span>
              <ul class="custom">
                <li>
                  <span @click="e => scrollTo('市場吸引力分析')">市場吸引力</span>
                  <ul class="custom">
                    <li>
                      <span @click="e => scrollTo('市場吸引力指標')">市場吸引力指標</span>
                    </li>
                    <li>
                      <span @click="e => scrollTo('市場吸引力操作教學說明')">市場吸引力操作教學說明</span>
                    </li>
                  </ul>
                </li>
              </ul>
              <ul class="custom">
                <li>
                  <span @click="e => scrollTo('市場競爭力分析')">市場競爭力</span>
                  <ul class="custom">
                    <li>
                      <span @click="e => scrollTo('市場競爭力指標')">市場競爭力指標</span>
                    </li>
                    <li>
                      <span @click="e => scrollTo('市場競爭力操作教學說明')">市場競爭力操作教學說明</span>
                    </li>
                  </ul>
                </li>
              </ul>
              <ul class="custom">
                <li>
                  <span @click="e => scrollTo('零售價格分析與指標')">零售價格分析與指標</span>
                  <ul class="custom">
                    <li>
                      <span @click="e => scrollTo('零售價格分析操作教學說明')">零售價格分析操作說明</span>
                    </li>
                  </ul>
                </li>
              </ul>
              <ul class="custom">
                <li>
                  <span @click="e => scrollTo('分析報告與操作說明')">分析報告與操作說明</span>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="main-container" :style="{ flex: 1, height: minHeight }">
      <div class="main-block col-block" :style="{ height: '100%', width: '100%', 'min-width': '1350px' }">
        <div class="title-container row-block">
          <div class="title">介紹與教學</div>
          <div :style="{ flex: 1 }"></div>
        </div>
        <div><div :style="{ height: '10px' }"></div></div>
        <tutorialMain
          :scrollToID="scrollToID"
        ></tutorialMain>
      </div>
    </div>
  </div>
</template>

<script>
import tutorialMain from '../../components/tutorial/main'

export default {
  components: {
    tutorialMain
  },
  props: {
    minHeight: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      scrollToID: null
    }
  },
  methods: {
    scrollTo (id) {
      this.scrollToID = id
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/main/tutorial.vue